export default "__VITE_ASSET__49f5d575__"